import e, { createContext as n, useContext as r, useRef as t, useCallback as o, useEffect as a, useMemo as l, useState as i } from "react";
import s from "prop-types";
import { css as c, cx as d } from "@leafygreen-ui/emotion";
import { usePrevious as u, useIdAllocator as p, useAvailableSpace as f, useEventListener as g, useViewportSize as h } from "@leafygreen-ui/hooks";
import { palette as m } from "@leafygreen-ui/palette";
import { Theme as b, createDataProp as v, isComponentType as y, consoleOnce as x, keyMap as w } from "@leafygreen-ui/lib";
import { fontFamilies as k, breakpoints as O, focusRing as N, spacing as E, hoverRing as S, BaseFontSize as C } from "@leafygreen-ui/tokens";
import { Label as D, Description as j } from "@leafygreen-ui/typography";
import { useUsingKeyboardContext as z, useDarkMode as I } from "@leafygreen-ui/leafygreen-provider";
import { transparentize as _ } from "polished";
import P, { Align as L, Justify as A } from "@leafygreen-ui/popover";
import M from "@leafygreen-ui/icon/dist/Checkmark";
import { isFragment as T } from "react-is";
import F from "lodash/isUndefined";
import G, { Size as V, Variant as R } from "@leafygreen-ui/button";
import B from "@leafygreen-ui/icon/dist/CaretDown";
import H from "@leafygreen-ui/icon/dist/Warning";
var K,
    Z,
    X = {
  XSmall: "xsmall",
  Small: "small",
  Default: "default",
  Large: "large"
},
    q = {
  None: "none",
  Error: "error"
};

function U(e, n) {
  var r = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    n && (t = t.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), r.push.apply(r, t);
  }

  return r;
}

function Y(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = null != arguments[n] ? arguments[n] : {};
    n % 2 ? U(Object(r), !0).forEach(function (n) {
      W(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : U(Object(r)).forEach(function (n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }

  return e;
}

function W(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}

function $() {
  return $ = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];

      for (var t in r) {
        Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
      }
    }

    return e;
  }, $.apply(this, arguments);
}

function J(e, n) {
  if (null == e) return {};

  var r,
      t,
      o = function (e, n) {
    if (null == e) return {};
    var r,
        t,
        o = {},
        a = Object.keys(e);

    for (t = 0; t < a.length; t++) {
      r = a[t], n.indexOf(r) >= 0 || (o[r] = e[r]);
    }

    return o;
  }(e, n);

  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);

    for (t = 0; t < a.length; t++) {
      r = a[t], n.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
    }
  }

  return o;
}

function Q(e, n) {
  return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(n)
    }
  }));
}

function ee(e, n) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, n) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null == r) return;
    var t,
        o,
        a = [],
        l = !0,
        i = !1;

    try {
      for (r = r.call(e); !(l = (t = r.next()).done) && (a.push(t.value), !n || a.length !== n); l = !0) {
        ;
      }
    } catch (e) {
      i = !0, o = e;
    } finally {
      try {
        l || null == r.return || r.return();
      } finally {
        if (i) throw o;
      }
    }

    return a;
  }(e, n) || re(e, n) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function ne(e) {
  return function (e) {
    if (Array.isArray(e)) return te(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || re(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function re(e, n) {
  if (e) {
    if ("string" == typeof e) return te(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? te(e, n) : void 0;
  }
}

function te(e, n) {
  (null == n || n > e.length) && (n = e.length);

  for (var r = 0, t = new Array(n); r < n; r++) {
    t[r] = e[r];
  }

  return t;
}

var oe,
    ae,
    le,
    ie,
    se,
    ce,
    de,
    ue,
    pe,
    fe,
    ge,
    he,
    me,
    be,
    ve,
    ye,
    xe = (W(K = {}, b.Light, {
  menu: {
    border: m.gray.light2,
    shadow: _(.75, m.black)
  },
  option: {
    group: {
      label: m.gray.dark1
    },
    background: {
      base: m.white,
      hovered: m.gray.light2,
      focused: m.blue.light3
    },
    text: {
      base: m.gray.dark3,
      selected: m.blue.base,
      disabled: m.gray.base,
      focused: m.blue.dark2
    },
    icon: {
      base: m.gray.dark1,
      selected: m.blue.base,
      disabled: m.gray.base
    },
    indicator: {
      focused: m.blue.base
    }
  }
}), W(K, b.Dark, {
  menu: {
    border: m.gray.base,
    shadow: _(.85, "#000000")
  },
  option: {
    group: {
      label: m.gray.base
    },
    background: {
      base: m.gray.dark3,
      hovered: m.gray.dark4,
      focused: m.blue.dark3
    },
    text: {
      base: m.gray.light2,
      selected: m.gray.light2,
      disabled: m.gray.dark2,
      focused: m.blue.light3
    },
    icon: {
      base: m.gray.base,
      selected: m.blue.light1,
      disabled: m.gray.dark1
    },
    indicator: {
      focused: m.blue.light1
    }
  }
}), K),
    we = (W(Z = {}, X.XSmall, {
  height: 22,
  text: 13,
  option: {
    text: 13
  },
  warningIcon: 16
}), W(Z, X.Small, {
  height: 28,
  text: 13,
  option: {
    text: 13
  },
  warningIcon: 16
}), W(Z, X.Default, {
  height: 36,
  text: 13,
  option: {
    text: 13
  },
  warningIcon: 16
}), W(Z, X.Large, {
  height: 48,
  text: 18,
  option: {
    text: 16
  },
  warningIcon: 16
}), Z),
    ke = 36,
    Oe = 16,
    Ne = {
  text: 16,
  lineHeight: 19
},
    Ee = {
  text: 16,
  lineHeight: 22
},
    Se = {
  text: 16
},
    Ce = n({
  theme: b.Light,
  size: X.Default,
  open: !1,
  disabled: !1
}),
    De = ["children", "className", "glyph", "selected", "focused", "disabled", "onClick", "onFocus", "triggerScrollIntoView", "hasGlyphs"],
    je = v("option"),
    ze = c(oe || (oe = Q(["\n  display: flex;\n  width: 100%;\n  outline: none;\n  overflow-wrap: anywhere;\n  transition: background-color 150ms ease-in-out;\n  position: relative;\n  padding: 8px 12px;\n\n  &:before {\n    content: '';\n    position: absolute;\n    transform: scaleY(0.3);\n    top: 7px;\n    bottom: 7px;\n    left: 0;\n    right: 0;\n    width: 4px;\n    border-radius: 0px 4px 4px 0px;\n    opacity: 0;\n    transition: all 150ms ease-in-out;\n  }\n"]))),
    Ie = c(ae || (ae = Q(["\n  display: flex;\n  align-items: center;\n  font-family: ", ";\n"])), k.default),
    _e = c(le || (le = Q(["\n  min-width: 16px;\n  margin-right: 6px;\n"]))),
    Pe = c(ie || (ie = Q(["\n  ", ":focus & {\n    color: currentColor;\n  }\n"])), je.selector);

function Le(n) {
  var l,
      i,
      s = n.children,
      p = n.className,
      f = n.glyph,
      g = n.selected,
      h = n.focused,
      m = n.disabled,
      b = n.onClick,
      v = n.onFocus,
      y = n.triggerScrollIntoView,
      x = n.hasGlyphs,
      w = J(n, De),
      k = r(Ce).theme,
      O = z().usingKeyboard,
      N = xe[k].option,
      E = t(null),
      S = o(function () {
    if (null == E.current) return null;
    var e = E.current,
        n = null == e ? void 0 : e.offsetParent;
    if (!n) return null;
    n.scrollTop = e.offsetTop + (e.clientHeight - n.clientHeight) / 2;
  }, [E]),
      C = u(y),
      D = y && !C;
  a(function () {
    D && S();
  }, [S, D]);
  var j = u(h),
      I = h && !j;
  a(function () {
    I && E.current.focus();
  }, [I]);

  var _,
      P = e.createElement("span", {
    className: d(Ie, W({}, c(se || (se = Q(["\n          font-weight: bold;\n        "]))), g))
  }, s),
      L = e.createElement("span", {
    className: d(_e, c(ce || (ce = Q(["\n          height: 100%;\n        "]))))
  }),
      A = L;

  f && (f.type.isGlyph ? A = e.cloneElement(f, {
    key: "glyph",
    className: d(_e, c(de || (de = Q(["\n            color: ", ";\n          "])), N.icon.base), (_ = {}, W(_, Pe, O), W(_, c(ue || (ue = Q(["\n              color: ", ";\n            "])), N.icon.disabled), m), _), f.props.className)
  }) : console.error("`Option` instance did not render icon because it is not a known glyph element."));
  var T,
      F = g ? e.createElement(M, {
    key: "checkmark",
    className: d(_e, c(pe || (pe = Q(["\n          color: ", ";\n        "])), N.icon.selected), (l = {}, W(l, Pe, O), W(l, c(fe || (fe = Q(["\n            color: ", ";\n          "])), N.icon.disabled), m), l))
  }) : L;
  return T = x ? e.createElement("span", {
    className: c(ge || (ge = Q(["\n          display: flex;\n          justify-content: space-between;\n          width: 100%;\n        "])))
  }, e.createElement("span", {
    className: c(he || (he = Q(["\n            display: flex;\n          "])))
  }, A, P), F) : e.createElement(e.Fragment, null, F, P), e.createElement("li", $({}, je.prop, w, {
    role: "option",
    "aria-selected": g,
    tabIndex: -1,
    ref: E,
    className: d(ze, c(me || (me = Q(["\n          cursor: pointer;\n          color: ", ";\n        "])), N.text.base), (i = {}, W(i, c(be || (be = Q(["\n            &:hover {\n              background-color: ", ";\n            }\n          "])), N.background.hovered), !m), W(i, c(ve || (ve = Q(["\n            &:focus {\n              color: ", ";\n              background-color: ", ";\n\n              &:before {\n                opacity: 1;\n                transform: scaleY(1);\n                background-color: ", ";\n              }\n            }\n          "])), N.text.focused, N.background.focused, N.indicator.focused), O && !m), W(i, c(ye || (ye = Q(["\n            cursor: not-allowed;\n            color: ", ";\n          "])), N.text.disabled), m), i), p),
    onClick: b,
    onFocus: v,
    onKeyDown: void 0
  }), T);
}

function Ae(e) {
  throw Error("`Option` must be a child of a `Select` instance");
}

Le.displayName = "Option", Ae.displayName = "Option";
var Me = s.oneOfType([s.string, s.number]);
Ae.propTypes = {
  children: s.oneOfType([Me, s.arrayOf(s.oneOfType([Me, s.oneOf([!1, null, void 0, ""])]))]).isRequired,
  className: s.string,
  glyph: s.element,
  value: s.string,
  disabled: s.bool
};
var Te,
    Fe,
    Ge,
    Ve = ["className", "label", "children"],
    Re = c(Te || (Te = Q(["\n  padding: 8px 0;\n"]))),
    Be = c(Fe || (Fe = Q(["\n  cursor: default;\n  width: 100%;\n  padding: 0 12px 2px;\n  outline: none;\n  overflow-wrap: anywhere;\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n"])));

function He(n) {
  var t = n.className,
      o = n.label,
      a = n.children,
      l = J(n, Ve),
      i = r(Ce).theme,
      s = xe[i].option,
      u = p({
    prefix: "select-option-group"
  });
  return e.createElement("div", $({
    className: d(Re, t)
  }, l), e.createElement("div", {
    id: u,
    className: d(Be, c(Ge || (Ge = Q(["\n            color: ", ";\n          "])), s.group.label))
  }, o), e.createElement("div", {
    role: "group",
    "aria-labelledby": u
  }, a));
}

function Ke(e) {
  throw Error("`OptionGroup` must be a child of a `Select` instance");
}

He.displayName = "OptionGroup", Ke.displayName = "OptionGroup", Ke.propTypes = {
  children: s.oneOfType([s.element, s.arrayOf(s.oneOfType([s.oneOf([!1, null, void 0, ""]), s.element]))]).isRequired,
  className: s.string,
  label: s.string.isRequired,
  disabled: s.bool
};
var Ze = ["children"];

function Xe(e) {
  return null == e || !1 === e || "" === e;
}

function qe(n, r) {
  e.Children.forEach(n, function (e) {
    y(e, "Option") ? r(e) : y(e, "OptionGroup") ? qe(e.props.children, function (n) {
      return r(n, e);
    }) : T(e) && qe(e.props.children, r);
  });
}

function Ue(n, r, t) {
  return e.Children.toArray(n).every(function (e) {
    return y(e, "Option");
  }) || e.Children.toArray(n).every(function (e) {
    return y(e, "OptionGroup");
  }) || x.warn("LeafyGreen Select: Combining grouped and ungrouped Select Options can cause styling issues"), e.Children.map(n, function (n) {
    if (y(n, "Option")) return e.createElement(Le, r(n));

    if (y(n, "OptionGroup")) {
      var o = n.props,
          a = o.children,
          l = J(o, Ze);
      return e.createElement(He, $({
        className: void 0
      }, l), Ue(a, function (e) {
        return r(e, n);
      }, t));
    }

    return T(n) ? Ue(n.props.children, r, t) : (Xe(n) || null == t || t(n), null);
  });
}

function Ye(e) {
  return null === e ? "" : void 0 !== e.props.value ? e.props.value : Array.isArray(e.props.children) ? e.props.children.filter(function (e) {
    return !Xe(e);
  }).join("") : e.props.children ? e.props.children.toString() : "";
}

function We(e, n) {
  var r, t, o;
  return null !== (r = e.props.disabled) && void 0 !== r && r || null !== (t = null == n || null === (o = n.props) || void 0 === o ? void 0 : o.disabled) && void 0 !== t && t;
}

function $e(e, n, r) {
  return Ye(e) === r && !We(e, n);
}

function Je(e) {
  var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = n.initialValue,
      o = n.deps,
      a = void 0 === o ? [] : o,
      i = t(r);
  return l(function () {
    return {
      get current() {
        return i.current;
      },

      set current(n) {
        i.current = n, e(n);
      }

    };
  }, [e, i].concat(ne(a)));
}

function Qe(e, n) {
  var r = o(function (e, n) {
    Array.isArray(e) ? e.forEach(r) : "function" == typeof e ? e(n) : e && (e.current = n);
  }, []);
  return Je(o(function (n) {
    return r(e, n);
  }, [e, r]), {
    initialValue: n
  });
}

var en,
    nn,
    rn,
    tn = function tn(e) {
  var n = ee(i(e), 2),
      r = n[0];
  return Je(n[1], {
    initialValue: e,
    deps: [r]
  });
},
    on = c(en || (en = Q(["\n  position: relative;\n  text-align: left;\n  width: 100%;\n  border-radius: 3px;\n  line-height: 16px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow: auto;\n"]))),
    an = function an(e, n) {
  var r = we[n],
      t = xe[e];
  return d(c(nn || (nn = Q(["\n      font-family: ", ";\n      font-size: ", "px;\n      min-height: ", "px;\n      background-color: ", ";\n      border-radius: 12px;\n      box-shadow: 0 4px 7px 0 ", ";\n      padding: 8px 0;\n    "])), k.default, r.option.text, r.height, t.option.background.base, t.menu.shadow));
},
    ln = e.forwardRef(function (n, t) {
  var a = n.children,
      l = n.id,
      i = n.referenceElement,
      s = n.className,
      u = n.labelId,
      p = n.usePortal,
      g = void 0 === p || p,
      h = n.portalContainer,
      m = n.scrollContainer,
      b = n.portalClassName,
      v = n.popoverZIndex,
      y = r(Ce),
      x = y.theme,
      w = y.size,
      k = y.disabled,
      N = y.open,
      E = Qe(t, null),
      S = f(i, 8),
      C = F(S) ? "unset" : "".concat(Math.min(S, 274), "px"),
      D = o(function (e) {
    E.current && E.current.focus(), e.stopPropagation();
  }, [E]),
      j = Y({
    popoverZIndex: v
  }, g ? {
    usePortal: g,
    portalClassName: b,
    portalContainer: h,
    scrollContainer: m
  } : {
    usePortal: g
  });
  return e.createElement(P, $({
    active: N && !k,
    spacing: 6,
    align: L.Bottom,
    justify: A.Middle,
    adjustOnMutation: !0,
    className: s,
    refEl: i
  }, j), e.createElement("ul", {
    "aria-labelledby": u,
    role: "listbox",
    ref: E,
    tabIndex: -1,
    onClick: D,
    className: d(on, an(x, w), c(rn || (rn = Q(["\n              max-height: ", ";\n              @media only screen and (max-width: ", "px) {\n                font-size: ", "px;\n              }\n            "])), C, O.Desktop, Se.text)),
    id: l
  }, a));
});

ln.displayName = "ListMenu";

var sn,
    cn,
    dn,
    un,
    pn,
    fn,
    gn,
    hn,
    mn,
    bn,
    vn,
    yn,
    xn,
    wn,
    kn,
    On,
    Nn,
    En,
    Sn,
    Cn,
    Dn,
    jn,
    zn,
    In,
    _n,
    Pn,
    Ln,
    An,
    Mn,
    Tn = ["children", "value", "text", "name", "deselected", "readOnly", "onClose", "onOpen", "errorMessage", "state", "baseFontSize", "__INTERNAL__menuButtonSlot__"],
    Fn = c(sn || (sn = Q(["\n  // Override button defaults\n  font-weight: 400;\n  > *:last-child {\n    grid-template-columns: 1fr 16px;\n    justify-content: flex-start;\n\n    > svg {\n      justify-self: right;\n      width: 16px;\n      height: 16px;\n    }\n  }\n"]))),
    Gn = (W(fn = {}, X.Default, c(cn || (cn = Q(["\n    > *:last-child {\n      padding: 0 4px 0 12px;\n    }\n  "])))), W(fn, X.Large, c(dn || (dn = Q(["\n    > *:last-child {\n      padding: 0 8px 0 16px;\n    }\n  "])))), W(fn, X.Small, c(un || (un = Q(["\n    > *:last-child {\n      padding: 0 4px 0 10px;\n    }\n  "])))), W(fn, X.XSmall, c(pn || (pn = Q(["\n    text-transform: none;\n    font-size: 13px;\n    line-height: 20px;\n    > *:last-child {\n      padding: 0 4px 0 10px;\n    }\n  "])))), fn),
    Vn = (W(mn = {}, b.Light, c(gn || (gn = Q(["\n    background-color: ", ";\n    // Override button default color\n    > *:last-child {\n      > svg {\n        color: ", ";\n      }\n    }\n  "])), m.white, m.gray.dark2)), W(mn, b.Dark, c(hn || (hn = Q(["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n\n    // Override button default color\n    > *:last-child {\n      > svg {\n        color: ", ";\n      }\n    }\n\n    &:hover,\n    &:active,\n    &:focus {\n      background-color: ", ";\n      color: ", ";\n    }\n  "])), m.gray.base, m.gray.dark4, m.gray.light3, m.gray.light1, m.gray.dark4, m.gray.light3)), mn),
    Rn = (W(yn = {}, b.Light, c(bn || (bn = Q(["\n    &:focus {\n      box-shadow: ", ";\n      border-color: rgba(255, 255, 255, 0);\n    }\n  "])), N.light.input)), W(yn, b.Dark, c(vn || (vn = Q(["\n    &:focus {\n      background-color: ", ";\n      box-shadow: ", ";\n      border-color: rgba(255, 255, 255, 0);\n    }\n  "])), m.gray.dark4, N.dark.input)), yn),
    Bn = (W(kn = {}, b.Light, c(xn || (xn = Q(["\n    color: ", ";\n  "])), m.gray.dark1)), W(kn, b.Dark, c(wn || (wn = Q(["\n    color: ", ";\n\n    &:hover,\n    &:active,\n    &:focus {\n      color: ", ";\n    }\n  "])), m.gray.light1, m.gray.light1)), kn),
    Hn = c(On || (On = Q(["\n  &:disabled {\n    cursor: not-allowed;\n    pointer-events: unset;\n    box-shadow: unset;\n\n    &:active {\n      pointer-events: none;\n    }\n  }\n"]))),
    Kn = (W(Sn = {}, b.Light, d(Hn, c(Nn || (Nn = Q(["\n      &:disabled {\n        background-color: ", ";\n        color: ", ";\n\n        > *:last-child {\n          > svg {\n            color: ", ";\n          }\n        }\n      }\n    "])), m.gray.light2, m.gray.base, m.gray.base))), W(Sn, b.Dark, d(Hn, c(En || (En = Q(["\n      &:disabled {\n        background-color: ", ";\n        color: ", ";\n        border-color: ", ";\n\n        > *:last-child {\n          > svg {\n            color: ", ";\n          }\n        }\n      }\n    "])), m.gray.dark3, m.gray.dark2, m.gray.dark2, m.gray.dark2))), Sn),
    Zn = c(Cn || (Cn = Q(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-grow: 1;\n  gap: ", "px;\n  overflow: hidden;\n"])), E[1]),
    Xn = c(Dn || (Dn = Q(["\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 100%;\n"]))),
    qn = (W(jn = {}, b.Light, m.red.base), W(jn, b.Dark, m.red.light1), jn),
    Un = (W(_n = {}, b.Light, c(zn || (zn = Q(["\n    border-color: ", ";\n    background-color: ", ";\n\n    &:hover,\n    &:active {\n      box-shadow: ", ";\n    }\n  "])), qn[b.Light], m.white, S.light.red)), W(_n, b.Dark, c(In || (In = Q(["\n    border-color: ", ";\n\n    &:hover,\n    &:active {\n      border-color: ", ";\n      box-shadow: ", ";\n    }\n  "])), qn[b.Dark], qn[b.Dark], S.dark.red)), _n),
    Yn = e.forwardRef(function (n, t) {
  var a,
      l,
      i = n.children,
      s = n.value,
      u = n.text,
      p = n.name,
      f = n.deselected;
  n.readOnly;

  var g = n.onClose,
      h = n.onOpen,
      m = n.errorMessage,
      v = n.state,
      y = n.baseFontSize,
      x = n.__INTERNAL__menuButtonSlot__,
      w = J(n, Tn),
      k = z().usingKeyboard,
      N = r(Ce),
      E = N.theme,
      S = N.open,
      C = N.size,
      D = N.disabled,
      j = Qe(t, null),
      I = we[C],
      _ = o(function () {
    S ? g() : h(), j.current.focus();
  }, [g, h, S, j]),
      P = x || G,
      L = x ? "" : d(Fn, Vn[E], Gn[C], (W(a = {}, Rn[E], k), W(a, Bn[E], f), W(a, Kn[E], D), W(a, Un[E], v === q.Error && !!m), W(a, c(Pn || (Pn = Q(["\n            letter-spacing: initial;\n          "]))), C === V.XSmall), a), c(Ln || (Ln = Q(["\n          width: 100%;\n          @media only screen and (max-width: ", "px) {\n            height: ", "px;\n            font-size: ", "px;\n          }\n        "])), O.Desktop, ke, Oe)),
      A = null !== (l = w["data-testid"]) && void 0 !== l ? l : "leafygreen-ui-select-menubutton";

  return e.createElement(P, $({}, w, {
    ref: j,
    name: p,
    value: s,
    disabled: D,
    onClick: _,
    variant: R.Default,
    darkMode: E === b.Dark,
    rightGlyph: e.createElement(B, null),
    size: C,
    "data-testid": A,
    className: d(L, W({}, c(An || (An = Q(["\n          font-size: ", "px;\n        "])), y), C === V.Default))
  }), e.createElement("div", {
    className: Zn
  }, e.createElement("div", {
    className: Xn
  }, u), v === q.Error && m && e.createElement(H, {
    role: "presentation",
    className: c(Mn || (Mn = Q(["\n              color: ", ";\n            "])), qn[E]),
    size: I.warningIcon
  })), i);
});

Yn.displayName = "MenuButton";

var Wn,
    $n,
    Jn,
    Qn,
    er,
    nr,
    rr,
    tr,
    or,
    ar,
    lr,
    ir = ["children", "darkMode", "size", "disabled", "allowDeselect", "placeholder", "className", "id", "label", "aria-labelledby", "description", "name", "defaultValue", "value", "onChange", "readOnly", "usePortal", "portalContainer", "scrollContainer", "portalClassName", "popoverZIndex", "errorMessage", "state", "baseFontSize", "__INTERNAL__menuButtonSlot__"],
    sr = c(Wn || (Wn = Q(["\n  display: flex;\n  flex-direction: column;\n\n  > label + button,\n  > p + button {\n    margin-top: 3px;\n  }\n"]))),
    cr = c($n || ($n = Q(["\n  font-size: 18px;\n  line-height: 22px;\n"]))),
    dr = function dr(e) {
  var n = e.darkMode,
      r = e.sizeSet;
  return c(Jn || (Jn = Q(["\n  font-family: ", ";\n  color: ", ";\n  font-size: ", "px;\n  margin-top: ", "px;\n  padding-left: 2px;\n  transition: color 100ms ease-in-out;\n  transition-delay: 100ms;\n"])), k.default, n ? m.red.light1 : m.red.base, r.text, E[1]);
};

function ur(n) {
  var r,
      t,
      s,
      u = n.children,
      f = n.darkMode,
      m = n.size,
      b = void 0 === m ? X.Default : m,
      v = n.disabled,
      y = void 0 !== v && v,
      x = n.allowDeselect,
      k = void 0 === x || x,
      N = n.placeholder,
      E = void 0 === N ? "Select" : N,
      S = n.className,
      z = n.id,
      _ = n.label,
      P = n["aria-labelledby"],
      L = n.description,
      A = n.name,
      M = n.defaultValue,
      T = n.value,
      F = n.onChange,
      G = n.readOnly,
      V = n.usePortal,
      R = void 0 === V || V,
      B = n.portalContainer,
      H = n.scrollContainer,
      K = n.portalClassName,
      Z = n.popoverZIndex,
      U = n.errorMessage,
      ne = void 0 === U ? "error message right here" : U,
      re = n.state,
      te = void 0 === re ? q.None : re,
      oe = n.baseFontSize,
      ae = void 0 === oe ? C.Body1 : oe,
      le = n.__INTERNAL__menuButtonSlot__,
      ie = J(n, ir),
      se = p({
    prefix: "select",
    id: z
  }),
      ce = l(function () {
    return null != P ? P : "".concat(se, "-label");
  }, [P, se]);
  _ || P || console.error("For screen-reader accessibility, label or aria-labelledby must be provided to Select.");
  var de = I(f),
      ue = de.darkMode,
      pe = de.theme,
      fe = "".concat(se, "-description"),
      ge = "".concat(se, "-menu"),
      he = ee(i(!1), 2),
      me = he[0],
      be = he[1],
      ve = tn(null),
      ye = p({
    prefix: "select"
  }),
      xe = tn(null),
      ke = we[b],
      Oe = l(function () {
    return {
      theme: pe,
      size: b,
      open: me,
      disabled: y
    };
  }, [pe, b, me, y]);
  a(function () {
    void 0 !== T && void 0 === F && !0 !== G && console.warn("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
  }, [F, G, T]);
  var Se = o(function () {
    be(!0);
  }, []),
      De = o(function () {
    be(!1), ve.current.focus();
  }, [ve]);
  a(function () {
    if (me) {
      var e = function e(_e2) {
        var n = ve.current.contains(_e2.target) || xe.current.contains(_e2.target);
        be(n);
      };

      return document.addEventListener("mousedown", e), function () {
        document.removeEventListener("mousedown", e);
      };
    }
  }, [xe, ve, me]);
  var je = l(function () {
    var e = null;
    return void 0 === T && void 0 !== M && qe(u, function (n, r) {
      $e(n, r, M) && (e = n);
    }), e;
  }, [u, M, T]),
      ze = ee(i(je), 2),
      Ie = ze[0],
      _e = ze[1];
  a(function () {
    var e;
    null !== Ie && _e(null !== (e = function (e, n) {
      var r, t, o, a, l, i, s, c;
      return qe(e, function (e) {
        if (e === n) l = n;else if (e.props.children === n.props.children && e.props.value === n.props.value) {
          var r;
          null !== (r = i) && void 0 !== r || (i = e);
        } else if (void 0 !== e.props.value && e.props.value === n.props.value) {
          var t;
          null !== (t = s) && void 0 !== t || (s = e);
        } else if (Ye(e) === Ye(n)) {
          var o;
          null !== (o = c) && void 0 !== o || (c = e);
        }
      }), null !== (r = null !== (t = null !== (o = null !== (a = l) && void 0 !== a ? a : i) && void 0 !== o ? o : s) && void 0 !== t ? t : c) && void 0 !== r ? r : null;
    }(u, Ie)) && void 0 !== e ? e : je);
  }, [u, je, Ie]);
  var Pe = l(function () {
    if (void 0 !== T) {
      var e = null;
      return qe(u, function (n, r) {
        $e(n, r, T) && (e = n);
      }), e;
    }

    return Ie;
  }, [u, Ie, T]),
      Ae = o(function (e, n) {
    void 0 === T && _e(e), null == F || F(Ye(e), n), Ge(void 0), De();
  }, [F, De, T]),
      Me = o(function (e, n) {
    return function (r) {
      r.preventDefault(), r.stopPropagation(), y || n || (Ae(e, r), De());
    };
  }, [y, De, Ae]),
      Te = ee(i(), 2),
      Fe = Te[0],
      Ge = Te[1],
      Ve = l(function () {
    var e = [];
    return k && e.push(null), qe(u, function (n, r) {
      We(n, r) || e.push(n);
    }), e;
  }, [u, k]),
      Re = o(function (e) {
    void 0 !== Fe && Ae(Fe, e);
  }, [Fe, Ae]),
      Be = o(function () {
    Ge(Ve[0]);
  }, [Ve]),
      He = o(function () {
    Ge(Ve[Ve.length - 1]);
  }, [Ve]),
      Ke = o(function () {
    if (void 0 === Fe || 0 === Ve.indexOf(Fe)) He();else {
      var e = Ve.indexOf(Fe) - 1;
      Ge(Ve[e]);
    }
  }, [Ve, Fe, He]),
      Ze = o(function () {
    if (void 0 === Fe || Ve.indexOf(Fe) === Ve.length - 1) Be();else {
      var e = Ve.indexOf(Fe) + 1;
      Ge(Ve[e]);
    }
  }, [Ve, Fe, Be]),
      Xe = o(function (e, n) {
    return function (r) {
      r.preventDefault(), r.stopPropagation(), y || n || Ge(e);
    };
  }, [y]),
      Je = o(function (e) {
    var n, r;

    if (!(e.ctrlKey || e.shiftKey || e.altKey)) {
      var t = null === (n = xe.current) || void 0 === n ? void 0 : n.contains(document.activeElement),
          o = null === (r = ve.current) || void 0 === r ? void 0 : r.contains(document.activeElement);
      if (o || t) switch (e.keyCode) {
        case w.Tab:
        case w.Escape:
          De(), Ge(void 0);
          break;

        case w.Enter:
        case w.Space:
          me && !o && e.preventDefault(), Re(e);
          break;

        case w.ArrowUp:
          !me && o && Se(), e.preventDefault(), Ke();
          break;

        case w.ArrowDown:
          !me && o && Se(), e.preventDefault(), Ze();
      }
    }
  }, [xe, ve, De, me, Re, Ke, Ze, Se]);
  g("keydown", Je);
  var Qe = h(),
      en = l(function () {
    var e = !1;
    return qe(u, function (n) {
      e || (e = void 0 !== n.props.glyph);
    }), e;
  }, [u]),
      nn = l(function () {
    return null !== Qe && null !== xe.current && void 0 === Fe && me;
  }, [Fe, xe, me, Qe]),
      rn = l(function () {
    var n = null === Pe;
    return e.createElement(Le, {
      className: void 0,
      glyph: void 0,
      selected: n,
      focused: null === Fe,
      disabled: !1,
      onClick: Me(null, !1),
      onFocus: Xe(null, !1),
      hasGlyphs: !1,
      triggerScrollIntoView: n && nn
    }, E);
  }, [nn, Fe, Me, Xe, E, Pe]),
      on = l(function () {
    return Ue(u, function (e, n) {
      var r = e === Pe,
          t = We(e, n);
      return Y(Y({}, e.props), {}, {
        className: e.props.className,
        glyph: e.props.glyph,
        selected: r,
        focused: e === Fe,
        disabled: t,
        children: e.props.children,
        hasGlyphs: en,
        onClick: Me(e, t),
        onFocus: Xe(e, t),
        triggerScrollIntoView: r && nn
      });
    }, function () {
      console.error("`Select` instance received child that is not `Option` or `OptionGroup`.");
    });
  }, [nn, u, Fe, Me, Xe, en, Pe]),
      an = Y({
    popoverZIndex: Z
  }, R ? {
    usePortal: R,
    portalClassName: K,
    portalContainer: B,
    scrollContainer: H
  } : {
    usePortal: R
  });
  return e.createElement("div", {
    className: d(sr, S)
  }, _ && e.createElement(D, {
    htmlFor: ye,
    id: ce,
    darkMode: ue,
    disabled: y,
    className: d((r = {}, W(r, cr, b === X.Large), W(r, c(Qn || (Qn = Q(["\n                font-size: ", "px;\n                line-height: 20px;\n              "])), ae), b === X.Default), r), c(er || (er = Q(["\n              // Prevent hover state from showing when hovering label\n              pointer-events: none;\n            "]))), c(nr || (nr = Q(["\n              @media only screen and (max-width: ", "px) {\n                font-size: ", "px;\n                line-height: ", "px;\n              }\n            "])), O.Desktop, Ne.text, Ne.lineHeight))
  }, _), L && e.createElement(j, {
    id: fe,
    darkMode: ue,
    disabled: y,
    className: d((t = {}, W(t, cr, b === X.Large), W(t, c(rr || (rr = Q(["\n                font-size: ", "px;\n                line-height: 20px;\n              "])), ae), b === X.Default), t), c(tr || (tr = Q(["\n              @media only screen and (max-width: ", "px) {\n                font-size: ", "px;\n                line-height: ", "px;\n              }\n            "])), O.Desktop, Ee.text, Ee.lineHeight))
  }, L), e.createElement(Ce.Provider, {
    value: Oe
  }, e.createElement(Yn, $({}, ie, {
    id: ye,
    ref: ve,
    name: A,
    readOnly: G,
    value: Ye(Pe),
    text: null !== Pe ? Pe.props.children : E,
    deselected: null === Pe,
    onOpen: Se,
    onClose: De,
    "aria-labelledby": ce,
    "aria-controls": ge,
    "aria-expanded": me,
    "aria-describedby": fe,
    "aria-invalid": te === q.Error,
    "aria-disabled": y,
    errorMessage: ne,
    state: te,
    baseFontSize: ae,
    __INTERNAL__menuButtonSlot__: le
  }), e.createElement(ln, $({
    labelId: ce,
    id: ge,
    referenceElement: ve,
    ref: xe,
    className: c(or || (or = Q(["\n              width: ", "px;\n            "])), null === (s = ve.current) || void 0 === s ? void 0 : s.clientWidth)
  }, an), k && rn, on))), te === q.Error && ne && e.createElement("span", {
    className: d(dr({
      darkMode: ue,
      sizeSet: ke
    }), c(ar || (ar = Q(["\n              @media only screen and (max-width: ", "px) {\n                font-size: ", "px;\n                line-height: ", "px;\n              }\n            "])), O.Desktop, Ee.text, Ee.lineHeight), W({}, c(lr || (lr = Q(["\n                // Hide error text when menu is open,\n                // so it doesn't peek around the menu corner\n                color: transparent;\n              "]))), me))
  }, ne));
}

ur.displayName = "Select", ur.propTypes = {
  label: s.string,
  "aria-labelledby": s.string,
  description: s.string,
  placeholder: s.string,
  className: s.string,
  darkMode: s.bool,
  size: s.oneOf(Object.values(X)),
  disabled: s.bool,
  id: s.string,
  value: s.string,
  defaultValue: s.string,
  onChange: s.func,
  readOnly: s.bool,
  errorMessage: s.string,
  state: s.oneOf(Object.values(q)),
  allowDeselect: s.bool,
  baseFontSize: s.oneOf(Object.values(C))
};
export { Ae as Option, Ke as OptionGroup, ur as Select, X as Size, q as State };